package com.lomdaat.ads.internal

import com.lomdaat.ads.internal.dto.VastXml
import com.lomdaat.ads.model.VideoAd
import nl.adaptivity.xmlutil.serialization.XML

internal object VastParser {

    private val xml = XML {
        defaultPolicy { ignoreUnknownChildren() }
    }

    fun parse(raw: String): VideoAd? {
        val doc = runCatching { xml.decodeFromString(VastXml.serializer(), raw.trim()) }.getOrNull()
            ?: return null
        val linear = doc.ad?.inLine?.creatives?.creatives
            ?.firstNotNullOfOrNull { it.linear } ?: return null
        val mediaFile = linear.mediaFiles?.mediaFiles?.firstOrNull { it.url.isNotBlank() }
            ?: return null

        return VideoAd(
            id = null,
            mediaUrl = mediaFile.url.trim(),
            mimeType = mediaFile.type,
            durationMs = parseClock(linear.duration),
            skipOffsetMs = parseClock(linear.skipOffset),
            impressionUrl = doc.ad.inLine.impression?.value?.trim()?.ifBlank { null },
            clickThroughUrl = linear.videoClicks?.clickThrough?.value?.trim()?.ifBlank { null },
            clickTrackingUrl = linear.videoClicks?.clickTracking?.value?.trim()?.ifBlank { null },
            width = mediaFile.width?.toIntOrNull(),
            height = mediaFile.height?.toIntOrNull(),
        )
    }

    /** Parses VAST clock "HH:MM:SS(.mmm)" into milliseconds. Returns null on bad input. */
    private fun parseClock(value: String?): Long? {
        if (value.isNullOrBlank()) return null
        val parts = value.trim().split(":")
        if (parts.size != 3) return null
        val hours = parts[0].toLongOrNull() ?: return null
        val minutes = parts[1].toLongOrNull() ?: return null
        val secParts = parts[2].split(".")
        val seconds = secParts[0].toLongOrNull() ?: return null
        val millis = secParts.getOrNull(1)?.padEnd(3, '0')?.take(3)?.toLongOrNull() ?: 0L
        return ((hours * 3600 + minutes * 60 + seconds) * 1000) + millis
    }
}
